import { GeneralService } from 'src/app/services/general.service';
import { NotificationService } from './../../../services/notification.service';
import { FormularioService } from './../../../services/formulario.service';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { AbstractControl, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { GeneralComponent } from 'src/app/shared/general.component';
import { DropDownListSiteRecebimentoDTO } from 'src/app/entity/dto/dropdownlist.component';
import { MatDialog } from '@angular/material/dialog';


@Component({
    // tslint:disable-next-line: component-selector
    selector: 'app-et004-card-V',
    templateUrl: './et004-card-V.component.html'
})

export class Et004CardVComponent extends GeneralComponent implements OnInit {
    public formulario?: FormGroup;
    public listSiteRecebimento?: Array<DropDownListSiteRecebimentoDTO> = new Array<DropDownListSiteRecebimentoDTO>();
    public listSiteRecebimentoOriginal?: Array<DropDownListSiteRecebimentoDTO> = new Array<DropDownListSiteRecebimentoDTO>();
    @Output() mkCalc = new EventEmitter();

    // tslint:disable-next-line: max-line-length
    constructor(protected formularioService: FormularioService, protected formBuilder: FormBuilder, protected notificationService: NotificationService, protected generalService: GeneralService, public dialog: MatDialog) {
        super('Consumo', false);
        this.formulario = this.formBuilder.group({
            consumo_poncho: [null, []],
            consumo_cruiser: [null, []],
            consumo_dermacor: [null, []],
          //  consumo_derosal: [null, []],
            consumo_talkum_gloss: [null, []],
            consumo_redigo: [null, []],
            criado_por: [null, []],
        });
    }

    async ngOnInit(): Promise<void> {
    }

    changeCollapse(): void {
        this.collapseCard = this.collapseCard ? false : true;
    }

    hasErrorFormControl(campoFormulario?: AbstractControl): string {
        return this.formularioService.hasErrorFormControl(campoFormulario);
    }

    async makeCalculations(): Promise<void> {
        this.mkCalc.emit();
    }
}


